import { render, staticRenderFns } from "./AddDelivery.vue?vue&type=template&id=1d5232cc&"
import script from "./AddDelivery.vue?vue&type=script&lang=js&"
export * from "./AddDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports